import request from '@/sheep/request';



export const submitFeedback = (data: any) => {
	return request({
		url: '/wish/feedback/submit',
		method: 'POST',
		data: data
	});
}
